import { logUsage } from 'owa-analytics';
import { timestamp } from 'owa-datetime';
import type { FluidLoadSource, FluidLoadOwaScenario, FluidOwaSource } from 'owa-fluid-validations';
import {
    convertFluidLoadOwaScenarioToString,
    convertFluidLoadSourceToString,
    convertFluidOwaSourceToString,
} from '../utils/convertEnumToString';

export default function fluidComponentLoaded(
    owaScenario: FluidLoadOwaScenario,
    owaSource: FluidOwaSource,
    source: FluidLoadSource,
    scenarioStartTime: number,
    wasRetry?: boolean
) {
    const scenarioString: string = convertFluidLoadOwaScenarioToString(owaScenario);
    const owaSourceString: string = convertFluidOwaSourceToString(owaSource);
    const sourceString: string = convertFluidLoadSourceToString(source);

    logUsage(
        'FluidComponentLoaded',
        {
            OwaScenario_1: scenarioString,
            ComponentSource_2: sourceString,
            WasRetry_3: !!wasRetry,
            OwaSource_4: owaSourceString,
            ElapsedTime_5: timestamp() - scenarioStartTime,
        },
        { isCore: true }
    );
}
